import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Services from "../components/Services";

const ServicesPage = () => {
    return (
        <div className="services-page-wrapper">
            <Helmet>
                <title>IT Services | VNM Hitech Solutions</title>
                <meta name="description" content="Explore the wide range of IT services offered by VNM Hitech Solutions, including web development, mobile apps, HR systems, and more in Karur." />
            </Helmet>
            <Header />
            <main style={{ paddingTop: '80px', minHeight: 'calc(100vh - 80px)' }}>
                <Services />
            </main>
            <Footer />
        </div>
    );
};

export default ServicesPage;
